import { useEffect, useState } from "react";
import { Icon, Button, Search } from "semantic-ui-react";
import "react-loading-skeleton/dist/skeleton.css";
import { jobSchedulingSearchDefaultOptions } from "../data";
import "react-datepicker/dist/react-datepicker.css";
import "../jobScheduling.css";
import * as jobSchedulingReducer from "../jobScheduling.reducer";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const getJobbingSearchOptions = () => {
  let options = jobSchedulingSearchDefaultOptions;
  if (localStorage.getItem("isXeroConnected") !== "true") options.pop();
  return options;
};

const JobSchedulingSearch = (props) => {
  const [data, setData] = useState([]);
  const [jobbingSearchOptions, setJobbingSearchOptions] = useState(
    getJobbingSearchOptions
  );
  const [openSearchList, setOpenSearchList] = useState(false);
  const [jobbingSearchKeyword, setJobbingSearchKeyword] = useState("");
  const [jobbingSearchType, setJobbingSearchType] = useState(null);
  const [jobbingSearchTypeFullName, setJobbingSearchTypeFullName] =
    useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [scheduledJobList, setScheduledJobList] = useState([]);
  const [technicianList, setTechnicianList] = useState([]);

  const onSearch = async (keyword = "", searchType = null) => {
    console.log(keyword);
    console.log(searchType);
    setSearchLoading(true);

    const result = await props.actionGetJobSchedulingList(keyword, searchType);
    if (result) {
      setSearchLoading(false);
      setData(result);
      setScheduledJobList(result.scheduledJobs);
      setSearchLoading(false);
    }
  };

  const handleJobbingSearchChange = (e) => {
    console.log(e.target.value);
    setOpenSearchList(true);
    if (e.target.value === "" && jobbingSearchType !== null) {
      setJobbingSearchOptions(jobSchedulingSearchDefaultOptions);
      setJobbingSearchType(null);
      setJobbingSearchTypeFullName(null);
      onSearch("", null);
      setOpenSearchList(false);
    }
    const updatedOptions = jobSchedulingSearchDefaultOptions.map((item) => ({
      ...item,
      value: (
        <span
          style={{
            color: "#grey",
            fontWeight: "normal",
            fontSize: 16,
          }}
        >
          Search by {item.value}:{" "}
          <span
            style={{
              color: "#000",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            {e.target.value}
          </span>
        </span>
      ),
    }));
    setJobbingSearchKeyword(e.target.value);
    setJobbingSearchOptions(updatedOptions);
  };

  const handleJobbingResultSelect = (e, { result }) => {
    const _type = result.key;
    const _typeFullName = result.title.props.children[1];
    setOpenSearchList(false);
    setJobbingSearchType(_type);
    setJobbingSearchTypeFullName("Search by " + _typeFullName);
    onSearch(jobbingSearchKeyword, _type);
  };

  const onHandleKeyPress = (e) => {
    if (e.key === "Enter" && jobbingSearchOptions.length > 0) {
      e.preventDefault(); // Prevent default Enter key behavior
      const _type = "All";
      const _typeFullName = "All";

      setOpenSearchList(false);

      setJobbingSearchType(_type);
      setJobbingSearchTypeFullName("Search by " + _typeFullName);
      onSearch(jobbingSearchKeyword, _type);
    }
  };

  return (
    <>
      <div
        className={
          jobbingSearchTypeFullName === null
            ? "jobbing-search-box-nosearch"
            : "jobbing-search-box"
        }
      >
        <Search
          placeholder="Search..."
          results={jobbingSearchOptions.map((item) => ({
            title: item.value,
            key: item.key,
          }))}
          onSearchChange={handleJobbingSearchChange}
          onResultSelect={handleJobbingResultSelect}
          onKeyPress={onHandleKeyPress}
          open={openSearchList}
          onBlur={() =>
            setTimeout(() => {
              setOpenSearchList(false);
            }, 100)
          }
          value={jobbingSearchKeyword}
        />
        {jobbingSearchTypeFullName && (
          <div className="job-search-type">{jobbingSearchTypeFullName}</div>
        )}
      </div>
      <hr />
      <div className="job-status" style={{ paddingRight: "0px !important" }}>
        <div style={{ marginTop: 5 }}>
          <Button
            className="active-status"
            icon="add"
            size="mini"
            style={{ width: "100%", fontSize: 14 }}
            onClick={() => {
              window.location.href = "/jobbing";
            }}
          >
            <Icon name="add" style={{ color: "#fff", marginLeft: -15 }} />
            New Job
          </Button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    scheduledJobs: state.jobScheduling.scheduledJobs,
    unscheduledJobs: state.jobScheduling.unscheduledJobs,
    selectedDay: state.jobScheduling.selectedDay,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(jobSchedulingReducer, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(JobSchedulingSearch)
);
